module.exports = __webpack_public_path__ + "img/company_expert_cert_bg.4ab7c6f0.png";